import { Component, Input, OnInit, ViewChild , OnDestroy} from '@angular/core';
import { Store } from '@ngrx/store';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { QueryStates } from '../query.reducer';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GraphicService } from './graphic.service';

@Component({
  selector: 'app-graphic',
  templateUrl: './graphic.component.html',
  styleUrls: ['./graphic.component.scss']
})
export class GraphicComponent implements OnInit , OnDestroy {

  @Input() queryid = '';
  @Input() listArguments;
  @Input() reportlocation;

  dataGrafic:any[]=[]; // daos requeridos para hacer distint
  valGraficDispersionPetrofisica: boolean;

  subscriptionProcessStore: Subscription;
  subscriptionJasper: Subscription;
  subscriptionPetrofisica: Subscription;

  msgSpiner = 'Cargando...';

  @ViewChild('mdOptionsGrap')  mdOptionsGrap: ModalDirective;

  registerDispersionForm: FormGroup;
  get fDis() {
    return this.registerDispersionForm.controls;
  }
  registerTendenciaForm: FormGroup;
  get fTen() {
    return this.registerTendenciaForm.controls;
  }
  listTipoGrafico = [];
  listTipoEstilo = [];
  listTipoEscala = [];
  selectTypeGrafico = '';

  listComponent: any[] = [];
  listUnit: any[]=[];

  constructor(
              private store: Store<QueryStates>,
              private formBuilder: FormBuilder,
              public spinner: NgxSpinnerService,
              private toastr: ToastrService,
              private graphicService: GraphicService
             ) {
    this.subscriptionProcessStore = this.store.select('processQueryState').subscribe(stateProcess => {
    this.processStateManage(stateProcess); } );
  }

  ngOnInit() {
    // console.log('iniciando modal')
      this.listTipoGrafico = [{type: 'Dispersion', image: 'assets/images/Dispersion.png'},
       {type: 'Tendencia', image: 'assets/images/Tendencia.png'}];
      this.listTipoEstilo = [{type: 'Puntos', value: 'puntos'}, {type: 'Lineas Rectas', value: 'lineas'}];
      this.listTipoEscala = [{type: 'Lineal', value: 'lineal'}, {type: 'Logarítmica', value: 'logaritmica'}];

      this.registerDispersionForm = this.formBuilder.group({
        estilo: [{type: 'Puntos', value: 'puntos'}, [Validators.required]], // estlo
        ejex: [null, [Validators.required]], // Eje X
        unidad1: [null, [Validators.required]], // Unidad
        escala1: [{type: 'Lineal', value: 'lineal'}, [Validators.required]], // Escala
        ejey: [null], // Eje Y
        unidad2: [null], // Unidad
        escala2: [{type: 'Lineal', value: 'lineal'}], // Escala
        level:[0],
        queryId:[""],
        reportName:[""]
      });

      this.registerTendenciaForm = this.formBuilder.group({
        serie1: [null, [Validators.required]], // Lista Componentes
        serie2: [null], // Lista Componentes
        serie3: [null], // Lista Componentes
        unidad: [null, [Validators.required]], // Lista Componentes
        estilo1: [{type: 'Puntos', value: 'puntos'}, [Validators.required]], // Lista Componentes
        estilo2: [{type: 'Puntos', value: 'puntos'}], // Lista Componentes
        estilo3: [{type: 'Puntos', value: 'puntos'}], // Lista Componentes
        level:[0],
        queryId:[""],
        reportName:[""]
      });

  }

  async processStateManage(stateProcess){
    // console.log('estado proceso desde query' , stateProcess);
    this.msgSpiner = 'Cargando ...';
    switch (stateProcess.stateProcess) {
      case 'Export Grafico':
        if(this.queryid ==='ReportePetrofisica' || this.queryid ==='HistoricoReportePetrofisica'){
          this.listTipoEstilo = [{type: 'Puntos', value: 'puntos'}, {type: 'Lineas Rectas', value: 'lineasRectas'}];
          console.log("Entro historico");
          this.listTipoGrafico = [{type: 'Dispersion', image: 'assets/images/Dispersion.png'}];
          this.valGraficDispersionPetrofisica = true;
          this.onOpenModalGraficoDispersion();
        }else{
          this.onOpenModalGrafico();
        }
        break;
      case 'Data Grafic':
        this.dataGrafic = stateProcess.options.data;
        // console.log('valores consutados, Total', this.dataGrafic)
        const distincUnidades = new Set(this.dataGrafic.map(item => item.UNITS));
        const distinctComponentes: any = new Set(this.dataGrafic.map(item => item.COMPONENT),);
        this.listComponent = Array.from(distinctComponentes).map(item => {
            return {key: 'COMPONENT', value: item}; });
        this.listUnit = Array.from(distincUnidades).map(item => {
            return {key: 'UNITS', value: item}; });
        break;
      default:
        break;
    }
  }

  selectGrafico(e){
    // console.log('Seleccion Tipo Grafico' , e.value);
    this.selectTypeGrafico = e.value.type ;
  }

  showValuesForm(){
    this.spinner.show();
    let val = true;
    let listArgumentsJasper: any[] = [];
    let map = new Map();
    let objectSend = {};
    if(this.selectTypeGrafico==='Dispersion'){
      if(this.queryid ==='ReportePetrofisica' ||this.queryid ==='HistoricoReportePetrofisica'){
        this.registerDispersionForm.controls.unidad1.setValue(" ");
      this.registerDispersionForm.controls.unidad2.setValue(" ");
      if(this.registerDispersionForm.status!=='INVALID'){
        objectSend = {
          estilo: this.registerDispersionForm.value.estilo.value,
          ejex: this.registerDispersionForm.value.ejex.value,
          escalax: this.registerDispersionForm.value.escala1.value,
          ejey: this.registerDispersionForm.value.ejey === null ? "": this.registerDispersionForm.value.ejey.value,
          escalay: this.registerDispersionForm.value.escala2 === null ? "": this.registerDispersionForm.value.escala2.value
        }
      }else{
        val = false;
      }
      }else{
        if(this.queryid === 'queryAguasDeProduccion'){
          this.reportlocation = '/ICP/Graficos DispersionAguasdeProd'
        }
        console.log('informacion de form', this.registerDispersionForm.value);
        if(this.registerDispersionForm.status!=='INVALID'){
          objectSend = {
            estilo: this.registerDispersionForm.value.estilo.value,
            ejex: this.registerDispersionForm.value.ejex.value,
            unidad1: this.registerDispersionForm.value.unidad1.value,
            escala1: this.registerDispersionForm.value.escala1.value,
            ejey: this.registerDispersionForm.value.ejey === null ? "": this.registerDispersionForm.value.ejey.value,
            unidad2: this.registerDispersionForm.value.unidad2 === null ? "": this.registerDispersionForm.value.unidad2.value,
            escala2: this.registerDispersionForm.value.escala2 === null ? "": this.registerDispersionForm.value.escala2.value
          }
        }else{
          val = false;
        }
      }
    }else if(this.selectTypeGrafico==='Tendencia'){
      console.log('informacion de form', this.registerTendenciaForm.value);
      if(this.registerTendenciaForm.status!=='INVALID'){
        objectSend = {
          serie1: this.registerTendenciaForm.value.serie1.value,
          serie2: this.registerTendenciaForm.value.serie2 === null ? "": this.registerTendenciaForm.value.serie2.value,
          serie3: this.registerTendenciaForm.value.serie3 === null ? "": this.registerTendenciaForm.value.serie3.value,
          unidad: this.registerTendenciaForm.value.unidad.value,
          estilo1: this.registerTendenciaForm.value.estilo1.value,
          estilo2: this.registerTendenciaForm.value.estilo2 === null ? "": this.registerTendenciaForm.value.estilo2.value,
          estilo3: this.registerTendenciaForm.value.estilo3 === null ? "": this.registerTendenciaForm.value.estilo3.value
        }
      }else{
        val = false;
      }
    }

    if(val){
      // console.log('Arguementos de la consulta principal' , this.listArguments);
      this.listArguments.forEach(argQuery => {
        let arg =  Object.assign ({}, argQuery);
        arg = this.formatArgumentDateString(arg);
        listArgumentsJasper.push(arg);
      });
      listArgumentsJasper = this.objectLogoName(listArgumentsJasper);
      listArgumentsJasper.forEach(element => {
        let valorArg = Object.assign ({}, element);
        let argname = valorArg.argid.replace('[', '').replace(']', '');
        objectSend[argname] = valorArg.argdata;
      });
      //console.log('Arguementos Acumulados para graficos' , this.listArguments);
      this.subscriptionJasper = this.graphicService.onGetJasper(this.reportlocation, objectSend, 'pdf', this.queryid).subscribe(res => {
        this.graphicService.executeReport(res, 'pdf', this.queryid);
        this.registerDispersionForm.reset();
        this.registerTendenciaForm.reset();
        this.spinner.hide();
        this.mdOptionsGrap.hide();
      }, err => {
        this.toastr.error("Error al exportar")
        this.registerDispersionForm.reset();
        this.registerTendenciaForm.reset();
        this.spinner.hide();
        this.mdOptionsGrap.hide();
      });
    }else{
      this.spinner.hide();
      /*this.registerDispersionForm.reset();
      this.registerTendenciaForm.reset();
      this.mdOptionsGrap.hide();*/
      this.toastr.warning("Información incompleta, campos vacios");
    }
  }

  onOpenModalGrafico() {
    this.mdOptionsGrap.show();
    this.selectTypeGrafico = '';
    this.mdOptionsGrap.show();
  }

  onCancelModal(){
      this.mdOptionsGrap.hide();
      this.mdOptionsGrap.config
      this.registerDispersionForm.reset();
      this.registerTendenciaForm.reset();
  }

  formatArgumentDateString( arg){
    if ((arg.argtype === 'dateonly' || arg.argtype === 'absreldt') && arg.argdata !== 'null') {
       // console.log("es fecha->" + arg.argdata, new Date(arg.argdata))
        let date = null;
        let day = "";
        let month = "";
        console.log("Mes: ", arg.argdesc, " :", new Date(arg.argdata).getMonth());
        if (new Date(arg.argdata).getDate() < 10) {
          day = '0' + new Date(arg.argdata).getDate();
        }
        if (new Date(arg.argdata).getMonth() +1 < 10) {
          month = '0' + (new Date(arg.argdata).getMonth() + 1);
        }
        date = new Date(arg.argdata);
        arg.argdata = `${day !== "" ? day : new Date(arg.argdata).getDate()}/${month !== "" ? month : new Date(arg.argdata).getMonth() + 1}/${new Date(arg.argdata).getFullYear()}`;
        arg.argtext = arg.argdata;
        arg.argtype === 'string';
    }
    return arg;
  }

  objectLogoName(args){
    let logoName = {
      "argdata":sessionStorage.getItem('logonName'),
      "argtext": sessionStorage.getItem('logonName'),
      "argid": "[LOGON_NAME]",
      "argdesc": "Usuario",
      "argtype": "string"
    }
    let sysUserId = {
      "argdata":sessionStorage.getItem('sysUserId'),
      "argtext": sessionStorage.getItem('sysUserId'),
      "argid": "[SYSUSERID]",
      "argdesc": "sysUserId",
      "argtype": "string"
    }
    args.push(logoName);
    args.push(sysUserId);
    return args;
  }

  onOpenModalGraficoDispersion(){
    this.selectTypeGrafico = '';
    this.ongetComponentPetrofisica();
    this.mdOptionsGrap.show();
  }

  ongetComponentPetrofisica(){
    this.spinner.show();
    let listArgumentsPetrofisica: any[] =[];
    this.listArguments.forEach(argQuery => {
      let arg =  Object.assign ({}, argQuery);
      arg = this.formatArgumentDateString(arg);
      listArgumentsPetrofisica.push(arg);
    });
    this.subscriptionPetrofisica = this.graphicService.onGetComponentPetrofisica(this.queryid, listArgumentsPetrofisica).subscribe((res: any[]) =>{
      this.listComponent = res;
      this.spinner.hide();
    }, err => {
     this.spinner.hide();
   });
  }

  public filterComponent(filter: any): void {
    this.listComponent = this.listComponent.filter((s) => s.text.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
  }

  public filterUnit(filter: any): void {
    this.listUnit = this.listUnit.filter((s) => s.text.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
  }

 ngOnDestroy() {
    if (this.subscriptionProcessStore){
      this.subscriptionProcessStore.unsubscribe();
    };
    if (this.subscriptionJasper){
      this.subscriptionJasper.unsubscribe();
    };
    if (this.subscriptionPetrofisica){
      this.subscriptionPetrofisica.unsubscribe();
    }
  }
}
